import { UiPricingCalculatorModel } from "../../models";

import {
    mockUiPricingPlanModel,
    mockUiPricingPlanModelContent
} from "./mock-ui-pricing-plan";

export function mockUiPricingCalculatorModel({
    id = "pricing-calculator-1234",
    type = "uiPricingCalculator",
    locale = "en",
    content = mockUiPricingCalculatorModelContent()
}: Partial<UiPricingCalculatorModel> = {}): UiPricingCalculatorModel {
    return {
        id,
        type,
        locale,
        content
    };
}

export type UiPricingCalculatorModelContent =
    UiPricingCalculatorModel["content"];

export function mockUiPricingCalculatorModelContent({
    title = "Pricing Calculator",
    userCountLabel = "How many users?",
    priceLabel = "Your price:",
    annualTotalText = "Total per year",
    perUserPerMonthText = "Per user per month",
    averagePricePerUserText = "Average price per user",
    usdText = "USD",
    generalError = "Please enter a number",
    minUsersError = "50 user minimum",
    maxUsersError = "10,000,000 user maximum",
    plan = mockUiPricingPlanModel({
        content: mockUiPricingPlanModelContent({
            pricing: [
                {
                    at: 250,
                    above: 0
                },
                {
                    at: 150,
                    above: 300
                },
                {
                    at: 100,
                    above: 500
                },
                {
                    at: 50,
                    above: 1000
                },
                {
                    at: 45,
                    above: 5000
                },
                {
                    at: 39,
                    above: 10000
                },
                {
                    at: 35,
                    above: 30000
                },
                {
                    at: 29,
                    above: 50000
                }
            ]
        })
    })
}: Partial<UiPricingCalculatorModelContent> = {}): UiPricingCalculatorModelContent {
    return {
        title,
        userCountLabel,
        priceLabel,
        annualTotalText,
        perUserPerMonthText,
        averagePricePerUserText,
        usdText,
        generalError,
        minUsersError,
        maxUsersError,
        plan
    };
}
